import React from 'react'
import { Header } from '../components/Header'
import Navbar from '../components/Navbar'
import Show from '../components/Show'

function Shows() {
  return (
    <div>
        <Navbar/>
        <Header heading="Shows"/>
        <Show/>
    </div>
  )
}

export default Shows